export default __webpack_public_path__ + "static/media/kid12.5a939a25.jpg";